 
import log from 'loglevel';
import { getAuthenticatedClient } from "../auth/authClient";

var graph = require('@microsoft/microsoft-graph-client');

export const getMessagesAndDispatch = async (teamId, channelId, accessToken, dispatch) =>{

  log.info(` getMessagesAndDispatch @ messageService`);
  log.debug(`getMessagesAndDispatch @ messageService accessToken: ${accessToken}`);

  const messegesUrl = `/teams/${teamId}/channels/${channelId}/messages`;
    
      
  const client = getAuthenticatedClient(accessToken);
    
  try {

   const res = await client
            .api(messegesUrl)
            .headers({
              "Content-Type" : "application/json;charset=UTF-8",
               "mode": "cors",
              "Access-Control-Allow-Origin" : '' 
            })
            .version('beta')
            .get((error, messages, rawResponse) => {

                  let someMessages =    messages.value.filter(message =>{                         
                    if (message.body.content.length > 0 ) return true;
                    return false;
                  });

                  let __items = [];
                  someMessages.forEach(message => {
                    let _message = 
                    {
                      id :  message.id,
                      date: message.createdDateTime ? message.createdDateTime : 'not available',
                      text : `[Message:]${message.body.content.trim().replace( /(<([^>]+)>)/ig, '')}`,
                      webUrl : message.webUrl,
                      user : message.from.user.displayName,
                      type : "Message",
                      selected : true
                    };
                    __items.push(_message);
                    }
                  );
                  const __itemsReversed = [...__items].reverse();  
                  dispatch({ type: "ADD_MESSAGES", payload: __itemsReversed });
              }//get
           )//get
          } catch (error) {
            log.error(`error / getMessagesAndDispatch @messageService ${JSON.stringify(error)}`);
        } finally {
            log.info(`finally / getMessagesAndDispatch @messageService`);
        }          
}
 